import { PropsWithChildren } from 'react';

import { QueryErrorResetBoundary } from '@tanstack/react-query';

import * as Sentry from '@sentry/react';
import { ErrorBoundary } from 'react-error-boundary';

import { ErrorFallback } from '@/widgets/ErrorFallback';

const ErrorBoundaryProvider = ({ children }: PropsWithChildren) => {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          onError={(error, info) => {
            Sentry.captureException(error, {
              extra: {
                componentStack: info.componentStack,
              },
            });
          }}
          fallbackRender={({ resetErrorBoundary }) => (
            <ErrorFallback onTryAgain={resetErrorBoundary} />
          )}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
};

export default ErrorBoundaryProvider;
